<template>
  <div style="width:100%; position: relative;
    background-color: rgba(255, 255, 255, 0.5);">

        <div :style="{width: getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'}">
            <div class="flexSpaceBetween" style="text-align: center;">
                <span class="heading"><h1>{</h1></span><span class="heading" style="top: 50px; position: relative;">Little bit about who we are?</span><span class="heading"><h1>}</h1></span>
            </div>        
        </div>
        <div class="flexSpaceBetween" style="flex-wrap: wrap; width: 70%; margin: 0 auto; text-align: center;">

            <div style="width: 100%; text-align: center; margin-top: 40px;">
                <span>
                Raizzon Infotech LLP were established in 2017. We have delivered solutions to our clients on a global scale, namely USA, UK, UAE, Australia, Sweden, Indonesia, and even further a field. We make it easy, for you.
                <br><br>
                We believe in simplicity; delivering software and services to you with complete ease of use. We represent the modern world and understand our clients needs, supporting you every step of the way. We don't want you to pay for hardware or software and rely on technical knowhow to get your business up and running.
                </span>
            </div>
            
        </div>
        
  </div>
</template>

<script>
export default {
    computed: {
        getScreenWidth() {
            return window.screen.width
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Home/Section6.vue